"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = Pin;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _SvgIcon = _interopRequireDefault(require("@material-ui/core/SvgIcon"));
var _ref = /*#__PURE__*/_react["default"].createElement("path", {
  fill: "none",
  d: "M0 0h24v24H0z"
});
var _ref2 = /*#__PURE__*/_react["default"].createElement("path", {
  d: "M16 12V4h1V2H7v2h1v8l-2 2v2h5.2v6h1.6v-6H18v-2z"
});
function Pin(props) {
  return /*#__PURE__*/_react["default"].createElement(_SvgIcon["default"], props, _ref, _ref2);
}
Pin.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * Override or extend the styles applied to the component.
   *
   * root - Styles applied to the root element.
   *
   * colorPrimary -Styles applied to the root element if color="primary".
   *
   * colorSecondary - Styles applied to the root element if color="secondary".
   *
   * colorAction - Styles applied to the root element if color="action".
   *
   * colorError - Styles applied to the root element if color="error".
   *
   * colorDisabled - Styles applied to the root element if color="disabled".
   *
   * fontSizeInherit - Styles applied to the root element if fontSize="inherit".
   *
   * fontSizeSmall - Styles applied to the root element if fontSize="small".
   *
   * fontSizeLarge - Styles applied to the root element if fontSize="large"
   */
  classes: _propTypes["default"].objectOf(_propTypes["default"].shape({
    colorAction: _propTypes["default"].object,
    colorDisabled: _propTypes["default"].object,
    colorError: _propTypes["default"].object,
    colorPrimary: _propTypes["default"].object,
    colorSecondary: _propTypes["default"].object,
    fontSizeInherit: _propTypes["default"].object,
    fontSizeLarge: _propTypes["default"].object,
    fontSizeSmall: _propTypes["default"].object,
    root: _propTypes["default"].object
  })),
  /**
   * @ignore
   */
  className: _propTypes["default"].string,
  /**
   * The color of the component. It supports those theme colors that make sense for this component.
   * You can use the `nativeColor` property to apply a color attribute to the SVG element.
   */
  color: _propTypes["default"].oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].func, _propTypes["default"].object]),
  /**
   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
   */
  fontSize: _propTypes["default"].oneOf(['default', 'inherit', 'large', 'medium', 'small']),
  /**
   * Applies a color attribute to the SVG element.
   */
  nativeColor: _propTypes["default"].string,
  /**
   * Provides a human-readable title for the element that contains it.
   * https://www.w3.org/TR/SVG-access/#Equivalent
   */
  titleAccess: _propTypes["default"].string,
  /**
   * Allows you to redefine what the coordinates without units mean inside an SVG element.
   * For example, if the SVG element is 500 (width) by 200 (height),
   * and you pass viewBox="0 0 50 20",
   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
   * to bottom right (50,20) and each unit will be worth 10px.
   */
  viewBox: _propTypes["default"].string
} : {};